import { buildCommonTrackingContext } from './buildCommonTrackingContext';
import { buildEventPayload } from './buildEventPayload';
import { logTrackingEvent } from './logTrackingEvent';
import { TRACK_USER_ACTION_EVENT } from './constants';

/**
 * Central API for Amplitude user-action events. Accepts semantic event params,
 * merges common game/user/runtime context, and fires via the SDK.
 * Works outside React (showoff, initialise) and inside components.
 */
export const trackUserAction = (params: Record<string, unknown>): void => {
  if (params.event === TRACK_USER_ACTION_EVENT.SCREEN_LOAD) {
    logTrackingEvent(buildEventPayload(params));
    return;
  }

  logTrackingEvent({
    ...buildCommonTrackingContext(),
    ...buildEventPayload(params),
  });
};
